<template>
  <div>
    <div>
      <h3>{{ folder.name }}</h3>
    </div>
    <edit-folder-modal :folderId="folderId"></edit-folder-modal>
    <move-folder-modal :folder="folder"></move-folder-modal>
    <delete-folder-modal :folderId="folderId"></delete-folder-modal>
    <create-requirement-modal :parentFolderId="folderId" modalId="create-requirement-modal-FolderDetail"></create-requirement-modal>
    <create-folder-modal :parentFolderId="folderId" modalId="create-folder-modal-FolderDetail"></create-folder-modal>
    <div class="detail-view-buttons">
      <b-button variant="secondary" size="sm" v-b-modal.edit-folder-modal>
        <icon name="pencil"></icon>
        Edit
      </b-button>
      <b-button variant="warning" size="sm" v-b-modal.move-folder-modal>
        Move
      </b-button>
      <b-button variant="danger" size="sm" v-b-modal.delete-folder-modal>
        Delete
      </b-button>
      <b-button variant="secondary" size="sm" v-b-modal.create-requirement-modal-FolderDetail>
        Create a requirement in this folder
      </b-button>
      <b-button variant="secondary" size="sm" v-b-modal.create-folder-modal-FolderDetail>
        Create a child folder
      </b-button>
    </div>
  </div>
</template>

<script>
  import CreateFolderModal from '@/components/modals/CreateFolderModal'
  import CreateRequirementModal from '@/components/modals/CreateRequirementModal'
  import DeleteFolderModal from '@/components/modals/DeleteFolderModal'
  import EditFolderModal from '@/components/modals/EditFolderModal'
  import MoveFolderModal from '@/components/modals/MoveFolderModal'
  export default {
    components: { CreateFolderModal, CreateRequirementModal, DeleteFolderModal, EditFolderModal, MoveFolderModal },
    data () {
      return {
        folder: {'name': ''}
      }
    },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      needToRefreshFolderDetail () {
        return this.$store.state.needToRefreshFolderDetail
      }
    },
    created () {
      if (this.folderId) {
        this.refreshData()
      }
      this.$watch('folderId', this.refreshData)
    },
    watch: {
      needToRefreshFolderDetail (currentValue) {
        if (currentValue === true) {
          // Refresh then set the value to be false
          this.refreshData()
          this.$store.commit('setNeedToRefreshFolderDetail', false)
        }
      }
    },
    props: {
      folderId: Number
    },
    methods: {
      getFolder () {
        this.$http.get(
          '/api/folder/' + this.folderId
        ).then(response => {
          this.folder = response.data.folder
        }, response => {
          console.log('error')
        })
      },
      refreshData () {
        this.getFolder()
      }
    }
  }

</script>

<style>
  .detail-view-buttons {
    margin-bottom: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// FolderDetail.vue?45642ece